// src/components/App/AppBarNoAccess.js

import React, { PureComponent } from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faPlus,
  faTimes,
  faTimesCircle,
  faChartLine,
  faCompressArrowsAlt,
  faStar,
  faChartBar,
  faSearchDollar,
  faUser,
  faUsers,
  faFolderOpen,
  faChevronUp,
  faChevronDown,
  faHandHoldingUsd,
  faDumbbell,
} from "@fortawesome/free-solid-svg-icons";

import "./AppBarNoAccess.css";

library.add(
  faPlus,
  faTimes,
  faTimesCircle,
  faChartLine,
  faCompressArrowsAlt,
  faStar,
  faChartBar,
  faSearchDollar,
  faUser,
  faUsers,
  faFolderOpen,
  faChevronUp,
  faChevronDown,
  faHandHoldingUsd,
  faDumbbell
);

class AppBarNoAccess extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showPrivate: false,
    };
  }

  getIcon(name) {
    switch (name) {
      case "my-portfolio-hub":
        return "PieLeftSlice.svg";
      case "model-performance":
        return "PortfolioCombo.svg";
      case "portfolio-analysis":
        return "ChartCombo.svg";
      case "custom-models":
        return "PieRightSlice.svg";
      case "fund-comparison":
        return "PieRightSlice.svg";
      case "capital-gains-comparison":
        return "Speedometer.svg";
      case "morningstar-ratings":
        return "Sunshine.svg";
      case "fibb":
        return "Barbell.svg";
      case "performance-at-a-glance":
        return "DoubleLineChart.svg";
      case "index-attribution":
        return "BarChart.svg";
      case "fund-attribution":
        return "BarChart.svg";
      case "chartaday":
        return "Growth.svg";
      case "yield":
        return "ArrowRight.svg";
      case "models":
        return "PortfolioCombo.svg";
      case "dashboard":
        return "ArrowRight.svg";
      case "befi":
        return "ArrowRight.svg";
      case "taxport":
        return "ArrowRight.svg";
      case "earnings":
        return "Money.svg";
      default:
        return "";
    }
  }

  mouseOn() {
    this.setState({ showPrivate: true });
  }

  mouseOff() {
    this.setState({ showPrivate: false });
  }

  render() {
    const {
      title,
      description,
      name,
      divId,
      activeApp,
      link,
      message,
      placement,
    } = this.props;
    const { showPrivate } = this.state;

    let appStyle = "naBarStyle";
    let columnClass = "col-md-4";
    let iconHolderStyle = "iconHolderStyle";
    let titleStyle = "titleStyle";
    let aniStyle = "aniStyle";
    let closeStyle = "closeStyle";
    let iconStyle = "iconStyle";
    const baseUrl = (process.env.REACT_APP_BASE_URL || "/").replace(
      /\/?$/,
      "/"
    );

    const renderIcon = () => {
      const iconPath = `${baseUrl}icons${
        showPrivate
          ? placement === "moreResources"
            ? "Off"
            : "On"
          : placement === "moreResources"
          ? "On"
          : "Off"
      }/${this.getIcon(name)}`;

      return (
        <div className={iconHolderStyle} aria-hidden="true">
          <img className={iconStyle} src={iconPath} alt={`${title} icon`} />
        </div>
      );
    };

    return (
      <div className={columnClass + " " + aniStyle}>
        {showPrivate && (
          <div
            className="naInfo"
            onMouseLeave={() => this.mouseOff()}
            onBlur={(e) => {
              // close only if focus leaves the whole .naInfo region
              if (!e.currentTarget.contains(e.relatedTarget)) this.mouseOff();
            }}
            role="region"
            tabIndex={-1}
            aria-label={`${title} access prompt`}
          >
            {activeApp === name && (
              <div className={closeStyle} aria-hidden="true">
                &nbsp;
              </div>
            )}
            {renderIcon()}
            <div className={titleStyle}>{message}</div>

            {activeApp !== name && (
              <div
                className="descriptionStyle"
                role="navigation"
                aria-label="Access links"
              >
                <a
                  href={`/sign-in?redirect=${link}`}
                  aria-label={`Sign in to access ${title}`}
                  onFocus={() => this.mouseOn()}
                >
                  Sign In
                </a>
                <a
                  href={`/registration/my-profile?redirect=${link}`}
                  aria-label={`Register to access ${title}`}
                  onFocus={() => this.mouseOn()}
                >
                  Register
                </a>
              </div>
            )}
          </div>
        )}
        {!showPrivate && (
          <div
            className={appStyle}
            onMouseEnter={() => this.mouseOn()}
            onMouseLeave={() => this.mouseOff()}
            onFocus={() => this.mouseOn()}
            onBlur={(e) => {
              if (!e.currentTarget.contains(e.relatedTarget)) {
                this.mouseOff();
              }
            }}
            role="button"
            tabIndex={0}
            aria-label={`${title} (no access)`}
            aria-expanded={showPrivate}
          >
            {activeApp === name && (
              <div className={closeStyle} aria-hidden="true">
                &nbsp;
              </div>
            )}
            {renderIcon()}
            <div className={titleStyle}>{title}</div>
            {activeApp !== name && (
              <div className="descriptionStyle">{description}</div>
            )}
          </div>
        )}
        <div className="appOffStyle" id={divId} aria-hidden="true"></div>
      </div>
    );
  }
}

export default AppBarNoAccess;



// WEBPACK FOOTER //
// ./src/components/App/AppBarNoAccess.js